import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FreeTrialModal from "../FreeTrialModal";
import logo1 from "../../assets/logo1.png";
import "aos/dist/aos.css";
import AOS from "aos";

const posts = [
  {
    slug: "how-ai-resume-screening-works-2025",
    title: "How AI Resume Screening Works in 2025",
    description:
      "Discover how AI-powered resume screening transforms hiring processes in 2025.",
    date: "Dec 5, 2025",
    content: `
      <section>
        <h2>Introduction</h2>
        <p>AI is revolutionizing recruitment by enabling faster, smarter, and unbiased candidate selection. Companies now use advanced algorithms to scan resumes and shortlist the best talent.</p>
      </section>
      <section>
        <h2>Step-by-Step AI Screening</h2>
        <ol>
          <li><strong>Upload Resumes:</strong> Gather resumes from applicants.</li>
          <li><strong>Parse & Analyze:</strong> AI extracts key skills, experience, and education.</li>
          <li><strong>Scoring & Ranking:</strong> Candidates are scored based on job requirements.</li>
          <li><strong>Shortlist:</strong> HR reviews top candidates for interviews.</li>
        </ol>
      </section>
      <section>
        <h2>Benefits</h2>
        <ul>
          <li>Faster recruitment cycle</li>
          <li>Reduced hiring bias</li>
          <li>Better candidate-job fit</li>
        </ul>
      </section>
      <section>
        <h2>Conclusion</h2>
        <p>AI resume screening is no longer optional—it’s the future of hiring. Adopt AI-driven recruitment today to save time, reduce bias, and hire the best talent efficiently.</p>
      </section>
    `,
  },
  {
    slug: "top-5-ai-hiring-trends-2025",
    title: "Top 5 AI Hiring Trends in 2025",
    description:
      "Explore the most impactful AI recruitment trends shaping hiring in 2025.",
    date: "Dec 10, 2025",
    content: `
      <section>
        <h2>Introduction</h2>
        <p>The hiring landscape is evolving rapidly with AI technologies leading the change. Companies that adapt quickly gain a competitive advantage.</p>
      </section>
      <section>
        <h2>Top Trends</h2>
        <ol>
          <li>AI-driven candidate sourcing</li>
          <li>Automated interview scheduling</li>
          <li>Predictive analytics for candidate fit</li>
          <li>Enhanced candidate engagement with AI chatbots</li>
          <li>Bias-free resume screening</li>
        </ol>
      </section>
      <section>
        <h2>Conclusion</h2>
        <p>Understanding these AI hiring trends will help HR teams optimize recruitment, improve candidate experience, and make data-driven hiring decisions.</p>
      </section>
    `,
  },
  {
    slug: "reduce-hiring-bias-ai-tools",
    title: "Reduce Hiring Bias with AI Tools",
    description:
      "Learn how AI ensures fair and unbiased candidate selection in modern recruitment.",
    date: "Dec 12, 2025",
    content: `
      <section>
        <h2>Introduction</h2>
        <p>Bias in recruitment can hurt company culture and talent acquisition. AI tools help remove human biases by objectively evaluating candidates.</p>
      </section>
      <section>
        <h2>How AI Reduces Bias</h2>
        <ul>
          <li>Anonymous resume screening</li>
          <li>Consistent candidate scoring algorithms</li>
          <li>Standardized evaluation criteria</li>
        </ul>
      </section>
      <section>
        <h2>Impact</h2>
        <p>Companies using AI recruitment report more diverse hires, improved employee satisfaction, and stronger retention rates.</p>
      </section>
    `,
  },
  {
    slug: "best-ai-recruitment-software-2025",
    title:
      "Best AI Recruitment Software for HR Teams in 2025: Complete Buyer’s Guide",
    description:
      "Discover the best AI recruitment software for HR teams in 2025. Learn features, benefits, pricing insights, and how to choose the right AI hiring platform.",
    date: "March 8, 2025",
    content: `
    <p>Hiring the right talent in 2025 is no longer about posting jobs and manually reviewing thousands of resumes. Today, <strong>AI recruitment software</strong> is transforming how HR teams source, screen, interview, and hire top candidates with speed, accuracy, and fairness.</p>

    <p>If your company is still relying on traditional hiring methods, you are already behind. This guide will help you understand <strong>what AI recruitment software is, how it works, its benefits, and how to choose the best AI hiring platform for your HR team.</strong></p>

    <h2>What Is AI Recruitment Software?</h2>
    <p>AI recruitment software uses artificial intelligence, machine learning, and automation to handle repetitive, time-consuming hiring processes such as resume screening, candidate ranking, interview scheduling, and document verification.</p>

    <p>Instead of HR teams manually reviewing applications, AI instantly analyzes resumes, extracts key skills, matches candidates to job descriptions, and scores them objectively.</p>

    <h2>Why HR Teams Are Switching to AI Hiring Tools in 2025</h2>
    <ul>
      <li>✅ 90% faster resume screening</li>
      <li>✅ Data-driven hiring decisions</li>
      <li>✅ Reduced unconscious hiring bias</li>
      <li>✅ Higher quality candidate shortlisting</li>
      <li>✅ Scalable hiring for startups & enterprises</li>
    </ul>

    <h2>Key Features to Look for in AI Recruitment Software</h2>
    <ul>
      <li><strong>AI Resume Parsing</strong> – Automatically extracts skills, experience, education.</li>
      <li><strong>Automated Candidate Scoring</strong> – Ranks candidates based on job relevance.</li>
      <li><strong>Bias-Free Hiring Engine</strong> – Removes gender, age, and background bias.</li>
      <li><strong>Interview Automation</strong> – AI video interviews & smart scheduling.</li>
      <li><strong>Document Verification & Onboarding</strong> – Instant document and hiring verification.</li>
    </ul>

    <h2>How AI Recruitment Software Works (Simple Breakdown)</h2>
    <ol>
      <li>HR uploads resumes into the AI system.</li>
      <li>AI extracts key data using natural language processing.</li>
      <li>AI compares candidates with job requirements.</li>
      <li>Smart algorithms rank candidates based on skills & experience.</li>
      <li>Top candidates are sent to HR for interviews.</li>
    </ol>

    <h2>Top Benefits of AI Recruitment Software</h2>
    <ul>
      <li><strong>Save Hiring Time:</strong> Reduce screening time from days to seconds.</li>
      <li><strong>Improve Hiring Accuracy:</strong> Data-backed decisions reduce bad hires.</li>
      <li><strong>Lower Hiring Costs:</strong> Automates expensive manual processes.</li>
      <li><strong>Fair & Transparent Hiring:</strong> Eliminates human bias.</li>
      <li><strong>Better Candidate Experience:</strong> Faster responses & real-time updates.</li>
    </ul>

    <h2>AI Recruitment Software vs Traditional Hiring</h2>
    <table border="1" cellpadding="10">
      <tr>
        <th>Traditional Hiring</th>
        <th>AI Recruitment Software</th>
      </tr>
      <tr>
        <td>Manual resume screening</td>
        <td>Automated AI screening</td>
      </tr>
      <tr>
        <td>High recruiter workload</td>
        <td>HR productivity boosted by 5x</td>
      </tr>
      <tr>
        <td>Prone to bias</td>
        <td>Objective, data-driven decisions</td>
      </tr>
      <tr>
        <td>Slow interview scheduling</td>
        <td>自动 interview scheduling</td>
      </tr>
    </table>

    <h2>Is AI Recruitment Software Suitable for Small Businesses?</h2>
    <p>Absolutely. Modern AI hiring tools are scalable, meaning startups, mid-sized companies, and large enterprises can all benefit. Many platforms offer flexible pricing, making AI hiring affordable even for small HR teams.</p>

    <h2>Future of AI Recruitment Software</h2>
    <p>By 2030, AI will handle over 80% of recruitment operations globally. Hiring will become predictive, skill-based, and fully automated—giving organizations an unbeatable competitive edge.</p>

    <h2>How Screenify Is Transforming AI Hiring</h2>
    <p>Screenify is an advanced AI-powered recruitment platform that automates resume screening, hiring decisions, Document verification, and employee onboarding — all in one platform.</p>

    <ul>
      <li>✅ Smart AI Resume Screening</li>
      <li>✅ Automated Hiring Decisions</li>
      <li>✅ Built-in Document Verification</li>
      <li>✅ Secure Digital Onboarding</li>
    </ul>

    <h2>Final Thoughts</h2>
    <p>Choosing the right AI recruitment software in 2025 is no longer optional — it’s mandatory for companies that want to stay competitive, hire faster, and build stronger teams. Whether you’re a startup or enterprise HR leader, AI will define your hiring success.</p>

    <p><strong>Ready to modernize your hiring process?</strong> Try Screenify today and experience the future of recruitment.</p>
  `,
  },
  {
    slug: "ai-recruitment-statistics-2025",
    title: "AI Recruitment Statistics You Must Know in 2025",
    description:
      "Explore key AI recruitment stats that are shaping hiring trends in 2025.",
    date: "Dec 15, 2025",
    content: `
      <section>
        <h2>Introduction</h2>
        <p>AI adoption in recruitment is growing rapidly. Companies leveraging AI report improved hiring efficiency, reduced bias, and better candidate experience.</p>
      </section>
      <section>
        <h2>Key Statistics</h2>
        <ul>
          <li>75% of HR leaders plan to implement AI recruitment tools by 2026.</li>
          <li>AI reduces resume screening time by 90% on average.</li>
          <li>Companies using AI report 50% faster hiring cycles.</li>
          <li>Diverse hiring improves by 40% using AI-powered screening.</li>
        </ul>
      </section>
      <section>
        <h2>Conclusion</h2>
        <p>Understanding AI recruitment stats helps HR teams make informed decisions and adopt best practices for smarter hiring in 2025.</p>
      </section>
    `,
  },
  {
    slug: "future-of-ai-in-hr-2025",
    title: "The Future of AI in HR: 2025 and Beyond",
    description:
      "Learn how AI is transforming HR and what the future holds for recruitment processes.",
    date: "Dec 18, 2025",
    content: `
      <section>
        <h2>Introduction</h2>
        <p>Artificial intelligence is reshaping human resources. From recruitment to employee engagement, AI brings efficiency, fairness, and predictive insights.</p>
      </section>
      <section>
        <h2>AI Trends in HR</h2>
        <ul>
          <li>Predictive hiring analytics</li>
          <li>Automated interview scheduling and feedback</li>
          <li>AI-driven employee retention strategies</li>
          <li>Bias-free performance evaluations</li>
        </ul>
      </section>
      <section>
        <h2>Impact on HR</h2>
        <p>HR teams can focus on strategic tasks while AI handles repetitive processes. AI adoption leads to faster hiring, better talent retention, and data-driven HR decisions.</p>
      </section>
    `,
  },
  {
    slug: "choosing-right-ai-hiring-software",
    title: "Choosing the Right AI Hiring Software for Your Business",
    description:
      "A guide to selecting the best AI recruitment platform tailored for your company’s needs.",
    date: "Dec 20, 2025",
    content: `
      <section>
        <h2>Introduction</h2>
        <p>Not all AI recruitment tools are equal. Choosing the right platform requires understanding features, scalability, and ROI.</p>
      </section>
      <section>
        <h2>Factors to Consider</h2>
        <ul>
          <li>Ease of use and integration with existing HR tools</li>
          <li>Accuracy of AI-driven candidate scoring</li>
          <li>Bias reduction capabilities</li>
          <li>Support for onboarding and document verification</li>
          <li>Cost vs benefit analysis</li>
        </ul>
      </section>
      <section>
        <h2>Conclusion</h2>
        <p>Selecting the right AI recruitment software can accelerate hiring, reduce costs, and improve overall HR efficiency. Test platforms with free trials before finalizing your choice.</p>
      </section>
    `,
  },
];

const BlogPost = () => {
  const { slug } = useParams();
  const [showTrial, setShowTrial] = useState(false);

  const post = posts.find((p) => p.slug === slug);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    window.scrollTo(0, 0);
  }, []);

  if (!post) {
    return (
      <div className="text-center py-5">
        <h2>Article not found</h2>
        <Link to="/blog" className="btn btn-primary mt-3">
          Back to Blog
        </Link>
      </div>
    );
  }

  const related = posts.filter((p) => p.slug !== slug).slice(0, 2);

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>{post.title} | Screenify Blog</title>
        <meta name="description" content={post.title} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.title} />
        <meta property="og:image" content={post.img} />
      </Helmet>

      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand mx-auto" to="/home">
            <img src={logo1} alt="logo" style={{ height: "50px" }} />
            <span className="web-name ms-2">Screenify</span>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About us
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/blog">
                  Blog
                </Link>
              </li>

              {/* <li className="nav-item">
                <button
                  className="btn btn-warning"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li> */}
            </ul>

            <ul className="navbar-nav ms-lg-auto mt-3 mt-lg-0 text-center">
              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <button
                  className="btn btn-warning w-100 w-lg-auto"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li>

              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/login"
                >
                  Login
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/signup"
                >
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <header
        className="py-5 text-white"
        style={{
          background: "linear-gradient(135deg, #007bff, #00c6ff)",
        }}
      >
        <div className="container text-center">
          <h1 className="display-4 fw-bold mb-3 animate__animated animate__fadeInUp">
            {post.title}
          </h1>
          <p className="lead">
            {post.author} • {post.date}
          </p>
        </div>
      </header>

      {/* CONTENT */}
      <section className="container my-5">
        <div className="row justify-content-center">
          <div
            className="col-lg-8"
            data-aos="fade-up"
            style={{
              background: "rgba(255,255,255,0.1)",
              backdropFilter: "blur(10px)",
              borderRadius: "20px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              padding: "30px",
            }}
          >
            <img
              src={post.img}
              alt={post.title}
              className="img-fluid rounded-4 mb-4 shadow"
            />

            <article
              className="blog-content"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </div>
        </div>
      </section>

      {/* RELATED POSTS */}
      <section className="py-5 bg-light">
        <div className="container">
          <h3 className="fw-bold mb-4" data-aos="fade-up">
            Related Articles
          </h3>
          <div className="row">
            {related.map((r) => (
              <div key={r.id} className="col-md-6 mb-4" data-aos="fade-up">
                <div
                  className="card border-0 shadow-sm hover-scale rounded-4"
                  style={{ overflow: "hidden" }}
                >
                  <img src={r.img} className="card-img-top" alt={r.title} />
                  <div className="card-body">
                    <h5 className="fw-bold">{r.title}</h5>
                    <Link
                      to={`/blog/${r.slug}`}
                      className="btn btn-outline-primary mt-3"
                    >
                      Read More →
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-5 bg-dark">
        <div className="container text-center text-white">
          <h2
            className="fw-bold display-5"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Get in Touch
          </h2>
          <p class="mb-4" data-aos="fade-up" data-aos-delay="300">
            We’d love to hear from you! Reach out with any questions or
            feedback.
          </p>

          <div
            className="row g-4 justify-content-center"
            style={{ borderBottom: "2px solid rgba(255, 255, 255, 0.3)" }}
          >
            {[
              {
                title: "Call Us",
                icon: "fas fa-phone-alt",
                lines: ["+91 96115 12281", "+91 90083 09255"],
                color: "text-primary",
              },
              {
                title: "Email",
                icon: "fas fa-envelope",
                lines: ["contactus@archipeltechnologies.com"],
                color: "text-warning",
              },
              {
                title: "Follow Us",
                icon: "fas fa-share-alt",
                social: true,
              },
            ].map((item, i) => (
              <div
                className="col-md-4 mb-3"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 200}
              >
                <div
                  className="p-4 rounded-4 shadow text-center hover-scale"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i className={`${item.icon} fa-3x mb-3 ${item.color}`}></i>
                  <h5 className="fw-bold mb-3">{item.title}</h5>

                  {item.social ? (
                    <div>
                      <a href="#" className="me-3">
                        <i className="fab fa-linkedin fa-2x text-primary"></i>
                      </a>
                      <a href="#" className="me-3">
                        <i
                          className="fab fa-instagram fa-2x"
                          style={{ color: "#E4405F" }}
                        ></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-youtube fa-2x text-danger"></i>
                      </a>
                    </div>
                  ) : (
                    item.lines.map((line, idx) => (
                      <p key={idx} className="mb-1">
                        {item.icon === "fas fa-envelope" ? (
                          <a
                            href={`mailto:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-warning`}></i>
                            {line}
                          </a>
                        ) : (
                          <a
                            href={`tel:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-primary`}></i>
                            {line}
                          </a>
                        )}
                      </p>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="bg-white text-dark py-3"
        // style={{
        //   background: "linear-gradient(90deg, #007bff, #00c6ff)",
        // }}
      >
        <div className="container d-flex justify-content-between">
          <p className="m-0">
            © Copyright {new Date().getFullYear()} Archipel Technlogies Pvt Ltd.
            . All Rights Reserved.
          </p>

          <div>
            <Link className="text-dark me-3" to="/privacy-policy">
              Privacy & Cookies
            </Link>
            <Link className="text-dark" to="/terms-and-conditions">
              Terms of Use
            </Link>
          </div>
        </div>
      </footer>

      <style>{`
        .hover-scale:hover {
          transform: translateY(-6px);
          transition: 0.3s;
        }
      `}</style>

      {showTrial && <FreeTrialModal onClose={() => setShowTrial(false)} />}
    </>
  );
};

export default BlogPost;
